<template>
  <section class="login">
    <div class="background" :style="{ 'background-color': themeConfig.bg_color }"></div>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="
            content-wrapper
            d-flex
            align-items-center
            justify-content-center
            auth
            theme-one
          ">
          <div class="row w-100">
            <div class="col-lg-4 mx-auto">
              <div class="auto-form-wrapper">
                <b-overlay :show="showLoading">
                  <div v-if="themeConfig.logo_url" class="text-center mb-3">
                    <img class="logo-img" :src="themeConfig.logo_url" />
                  </div>
                  <div class="text-center mb-3">
                    <h4>{{ organizationName }} 管理後台</h4>


                    <div class="mb-2 h4 font-weight-normal mt-4">請輸入認證碼</div>
                    <p v-if="successDeliveryMessage" class="text-success mb-2">{{ successDeliveryMessage }}</p>
                    <p>驗證碼將於 <span class="font-weight-bold mx-1" :class="otpRemainingSeconds <= 60 ? 'text-danger' : 'text-primary'">{{ formatTime(otpRemainingSeconds) }}</span> 後失效</p>
                  </div>


                  <form @submit.prevent="submit" novalidate>
                    <validation-error-alert v-if="validationErrors" :errors="validationErrors"></validation-error-alert>


                    <div class="form-group code-input">
                      <CodeInput ref="codeInput" :loading="false" :fields="6" :fieldHeight="80"
                        class="google-sans-code" @change="onCodeChange" @complete="onCodeComplete" />
                    </div>



                    <div class="text-center mb-2">收不到驗證碼？
                      <a v-if="resendRemainingSeconds <= 0" class="cursor-pointer font-weight-bold ml-1 text-primary" @click="handleResend">重新發送驗證碼</a>
                      <span v-else class="text-muted ml-1">{{ formatTime(resendRemainingSeconds) }}重新發送驗證碼</span>
                    </div>

                    <div class="text-center mb-4">
                      <router-link :to="{ name: 'AuthLogin', params: { org_code: $route.params.org_code } }" class="cursor-pointer">返回重新登入</router-link>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-primary submit-btn btn-block" :disabled="isSubmitting || otpRemainingSeconds <= 0">
                        送出
                      </button>
                    </div>
                  </form>
                </b-overlay>
              </div>
              <p v-if="footerText" class="footer-text text-center">
                {{ footerText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CodeInput from "@/components/CodeInput";

import { mapState } from "vuex";
export default {
  components: { CodeInput },
  data() {
    return {
      showLoading: false,
      isSubmitting: false,
      isResending: false,
      validationErrors: null,
      otpContext: null,
      timer: null,
      otpRemainingSeconds: 0,
      resendRemainingSeconds: 0,
      form: {
        code: null,
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      organizationThemeConfig: (state) => state.organizationThemeConfig,
    }),

    organizationName() {
      return this.organization ? this.organization.name : "Waltily";
    },
    themeConfig() {
      if (this.organizationThemeConfig.auth) {
        return this.organizationThemeConfig.auth;
      } else {
        return {
          bg_color: "#4c4c4c",
          logo_url: null,
          og_title: null,
          og_favicon_url: null,
          enable_captcha: false,
        };
      }
    },
    footerText() {
      return this.organizationThemeConfig?.auth?.footer_text
    },
    successDeliveryMessage() {
      if (!this.otpContext || !this.otpContext.success_delivery_methods) return '';
      const methods = this.otpContext.success_delivery_methods;
      const translations = {
        email: '信箱',
        mobile_phone: '手機',
      };
      
      const translated = methods.map(m => translations[m] || m).join('與');
      return `已發送驗證碼至您的${translated}`;
    }
  },
  mounted() {
    const otpContextJson = sessionStorage.getItem("otp_context");
    
    if (!otpContextJson) {
      this.$router.replace({
        name: "AuthLogin",
        params: { org_code: this.$route.params.org_code },
      });
      return;
    }

    try {
      this.otpContext = JSON.parse(otpContextJson);
      const now = Math.floor(Date.now() / 1000);
      
      if (this.otpContext.expired_at && this.otpContext.expired_at <= now) {
        this.$router.replace({
          name: "AuthLogin",
          params: { org_code: this.$route.params.org_code },
        });
        return;
      }
    } catch (e) {
      this.$router.replace({
        name: "AuthLogin",
        params: { org_code: this.$route.params.org_code },
      });
      return;
    }

    if (
      this.themeConfig.og_title !== null ||
      this.themeConfig.og_title !== undefined
    ) {
      document.title = this.themeConfig.og_title;
    } else {
      document.title = "";
    }

    if (
      this.themeConfig.og_favicon_url !== null ||
      this.themeConfig.og_favicon_url !== undefined
    ) {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = this.themeConfig.og_favicon_url;
    }

    this.startTimer();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    formatTime(totalSeconds) {
      if (totalSeconds <= 0) return '0 秒';

      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const minuteText = minutes > 0 ? `${minutes} 分 ` : '';
      const secondText = seconds > 0 || minutes === 0 ? `${seconds} 秒` : '';

      return `${minuteText}${secondText}`.trim();
    },
    startTimer() {
      this.updateTimers();
      this.timer = setInterval(this.updateTimers, 1000);
    },
    updateTimers() {
      if (!this.otpContext) return;
      const now = Math.floor(Date.now() / 1000);
      
      const newOtpRemaining = Math.max(0, this.otpContext.expired_at - now);
      const newResendRemaining = Math.max(0, this.otpContext.can_resend_at - now);

      // Trigger swal only once when it directly hits 0 from a positive number
      if (this.otpRemainingSeconds > 0 && newOtpRemaining === 0) {
        this.$swal("提示", "驗證碼已過期失效，請點擊重新發送！", "warning");
      }

      this.otpRemainingSeconds = newOtpRemaining;
      this.resendRemainingSeconds = newResendRemaining;

      if (this.otpRemainingSeconds === 0 && this.resendRemainingSeconds === 0) {
        // Option to clearInterval if we don't expect changes, 
        // but we might click resend, so keep the timer running to catch new context.
      }
    },
    onCodeChange(code) {
      this.form.code = code;
    },
    onCodeComplete(code) {
      this.form.code = code;
    },
    async submit() {
      if (!this.form.code || this.form.code.length < 6) {
        this.$swal("提示", "請輸入完整的 6 碼驗證碼", "warning");
        return;
      }
      
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.showLoading = true;

      const params = {
        org_id: this.otpContext.org_id,
        staff_id: this.otpContext.staff_id,
        otp_session_id: this.otpContext.otp_session_id,
        code: this.form.code,
      };

      try {
        await this.$store.dispatch("auth/verifyOtp", params);
        
        sessionStorage.removeItem("otp_context");
        this.$router.push({
          name: "DashboardJump",
          params: { org_code: this.$route.params.org_code },
        });

      } catch (error) {
        console.error(error);
        if (error.response && error.response.status) {
          const status = error.response.status;
          const msg = error.response.data.message || "驗證碼無效或已過期";
          
          if ([400, 422, 429].includes(status)) {
            this.$swal("驗證失敗", msg, "error");
          } else {
            this.$swal("失敗", msg, "error");
          }
        }
      } finally {
        this.isSubmitting = false;
        this.showLoading = false;
      }
    },
    async handleResend() {
      if (this.isResending) return;
      this.isResending = true;
      this.showLoading = true;

      const params = {
        org_id: this.otpContext.org_id,
        staff_id: this.otpContext.staff_id,
        otp_session_id: this.otpContext.otp_session_id,
      };

      try {
        const res = await this.$store.dispatch("auth/resendOtp", params) || await import('@/apis/https').then(m => m.default.post("/dashboard/auth/resend-otp", params)); // In case missing in store, direct call

        if (res.data.status === 'success') {
          this.otpContext.expired_at = res.data.data.expired_at;
          this.otpContext.can_resend_at = res.data.data.can_resend_at;
          if (res.data.data.success_delivery_methods) {
            this.otpContext.success_delivery_methods = res.data.data.success_delivery_methods;
          }
          
          sessionStorage.setItem("otp_context", JSON.stringify(this.otpContext));
          this.updateTimers();
          this.$swal("成功", "已重新發送驗證碼", "success");
        }

      } catch (error) {
        console.error(error);
        if (error.response && error.response.data) {
          const resData = error.response.data;
          this.$swal("重新發送失敗", resData.message || "請稍後再試", "error");
          
          if (error.response.status === 429 && resData.can_resend_at) {
             this.otpContext.can_resend_at = resData.can_resend_at;
             sessionStorage.setItem("otp_context", JSON.stringify(this.otpContext));
             this.updateTimers();
          }
        } else {
          this.$swal("失敗", "發生未知錯誤", "error");
        }
      } finally {
        this.isResending = false;
        this.showLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.background {
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.logo-img {
  width: 150px;
}

.code-input {

  ::v-deep .react-code-input-container {
    margin: auto;
    text-align: center;
    width: 100% !important;
  }

  ::v-deep input {
    border: 1px solid #636366 !important;
    width: 100% !important;
    font-size: 50px;
    font-weight: 600;
    color: var(--primary-color) !important;
  }
}
</style>
